module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-ii/banner--procedures@3x-ebe78adbaec2d155cc36bf7710cf806a.jpg";